import type { CdDossierTab, CdCrawlTab } from './types';

/** Page meta for the Competitor Dossier detail view. */
export const GROWTH_COMPETITOR_DOSSIER_META = {
  eyebrow: 'Local Market Intelligence',
  titleLead: 'Competitor',
  titleAccent: 'dossier',
  description:
    'A full intelligence profile on a single competing practice — their strengths, weaknesses, paid strategy, local SEO footprint, and social presence, scored against your clinic.',
} as const;

/** Page meta for the Competitor Crawl Report (website analysis) detail view. */
export const GROWTH_COMPETITOR_CRAWL_META = {
  eyebrow: 'Local Market Intelligence',
  titleLead: 'Competitor website',
  titleAccent: 'analysis',
  description:
    'An AI-powered crawl report with actionable insights for your practice — content gaps, technical issues, and the weak pages you can outrank.',
} as const;

/** Tabs for the Competitor Dossier view. */
export const CD_DOSSIER_TABS: readonly CdDossierTab[] = [
  { id: 'overview', label: 'Overview' },
  { id: 'ads', label: 'Google Ads' },
  { id: 'seo', label: 'Local SEO' },
  { id: 'social', label: 'Social' },
] as const;

/** Tabs for the Competitor Crawl Report view. */
export const CD_CRAWL_TABS: readonly CdCrawlTab[] = [
  { id: 'overview', label: 'Overview' },
  { id: 'content', label: 'Content Gaps' },
  { id: 'technical', label: 'Technical' },
  { id: 'pages', label: 'Page Analysis' },
] as const;

/** Filter chips for the crawled-pages table. */
export const CD_PAGE_FILTERS: readonly string[] = ['All', 'Service', 'Blog', 'Landing'] as const;
